import { getFeature } from "@soluto-private/expert-workspace-feature-flagging";
import { useQuery } from "@tanstack/react-query";
import { useExpertAssistStore } from "../state/store";
import { envName } from "./features";

export const useFeatureFlag = <T = boolean>(
    featureFlag: string,
    context: Record<string, unknown> = {},
    cacheTtl?: number,
) => {
    const { expertProfile, lob } = useExpertAssistStore();

    const { data, isLoading, isError } = useQuery({
        queryKey: [featureFlag, ...Object.values(context), expertProfile.id, lob],
        queryFn: async (): Promise<T | undefined> =>
            getFeature<T>(
                featureFlag,
                {
                    environment: envName,
                    channel: "voice",
                    employeeId: expertProfile.id,
                    appName: "expert-assist-standalone",
                    source: "expert-assist",
                    lob,
                    ...context,
                },
                cacheTtl,
            ),
        refetchOnMount: false,
    });
    return { data, isLoading, isError };
};
